module.exports = __webpack_public_path__ + "static/machine-installation-5-8b36d956ca0016fc53ebaaf80098d3ef.jpg";